export const KB_SIZE = 1024;
export const MB_SIZE = KB_SIZE * 1024;
export const GB_SIZE = MB_SIZE * 1024;
